import { Component, OnInit } from '@angular/core';
import { RegistrationserviceService } from '../services/registrationservice.service';
import { Registration } from '../Models/registration';
import { Router } from '@angular/router';
import { debug } from 'util';
import { DOCUMENT } from "@angular/platform-browser";
import { CookieService } from '../services/cookie.service';
import { BrowseobligorService } from '../services/browseobligor.service';

declare function responsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function HomeresponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function IssuersAndObligorsVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function DACForInvestorsVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function DMCAresponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function LegalInformationresponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function AboutresponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function AboutSecuritiesresponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function AboutComplianceresponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function HelpresponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function SitemapresponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function BrowseObligorsponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function WebCastresponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function FLFinancialStatementresponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function CheckforSession(targetid): any;
declare function LoadZoomText(): any;
declare function resizeText(targetid): any;
declare var $: any;
declare const glbVarOnOff: any;

declare function increaseFontSize(): any;
declare function decreaseFontSize(): any;
declare function resetFontSize(): any;
// For H4
declare function increaseFontSizeH4(): any;
declare function decreaseFontSizeH4(): any;

// For H3
declare function increaseFontSizeH3(): any;
declare function decreaseFontSizeH3(): any;

// For input
declare function increaseFontSizeinput(): any;
declare function decreaseFontSizeinput(): any;

// For h2
declare function increaseFontSizeH2(): any;
declare function decreaseFontSizeH2(): any;

// For textarea
declare function increaseFontSizetextarea(): any;
declare function decreaseFontSizetextarea(): any;


// For td
declare function increaseFontSizetd(): any;
declare function decreaseFontSizetd(): any;

//lebel
// For td
declare function increaseFontSizelabel(): any;
declare function decreaseFontSizelabel(): any;

// For span

//lebel
// For td
declare function increaseFontSizespan(): any;
declare function decreaseFontSizespan(): any;


declare function increaseVoiceSpeed(): any;
declare function decreaseVoiceSpeed(): any;
declare function resetVoiceSpeed(): any;
declare function voiceforincreasedecrease(targetid): any;

declare function LoadSettingsDropdown(): any;
declare function VoiceAnnotation(event): any;

declare function SettingsVoice(targetid): any;
declare function FontSizeSettings(): any;
declare function MagnifierEnableDisable(targetid): any;

@Component({
  selector: 'app-dacheader',
  templateUrl: './dacheader.component.html',
  styleUrls: ['./dacheader.component.css']
})
export class DacheaderComponent implements OnInit {
  route: string;
  pathname = '';
  public Islogin: boolean = false;
  constructor(private browseobligorService: BrowseobligorService,private registrationservice: RegistrationserviceService, private router: Router, private cookieService: CookieService) { }
  onClick(event: any) {
    if (event.target.id == "logoutClick") {
      this.registrationservice.LogoutInvestorAccount().subscribe(data => {
      });
      CheckforSession("LogoutPageHit");
      this.InvestorAccount();
      return;
    }
    if (event.target.id == "btndecreasevoice") {
      decreaseVoiceSpeed();
      return;
    }
    if (event.target.id == "btnincreasevoice") {
      increaseVoiceSpeed();
      return;
    }
    if (event.target.id == "btnresetvoice") {
      resetVoiceSpeed();
      return;
    }

    if (event.target.id == "btnDarkTheme") {
      document.getElementById('theme').setAttribute('href', 'assets/style-sheet/mastertheme.css');
      if ($('#btnDarkTheme').val() == "OFF") {
        var lighttheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
        lighttheme.value = "OFF";
        $('#btnDarkTheme').val('ON');
        var btnDarkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
        btnDarkTheme.disabled = true;
        //btnDarkTheme.style.cursor = "not-allowed";        
        //document.getElementById("btnDarkTheme").style.cursor = "not-allowed";       

        var btnLightTheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
        btnLightTheme.disabled = false;
        $('#hdnDarkTheme').val('ON');
        $('#hdnLightTheme').val('OFF');
        return;
      }
      if ($('#btnDarkTheme').val() == "ON") {
        var lighttheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
        lighttheme.value = "ON";
        $('#btnDarkTheme').val('OFF');
        var btnDarkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
        btnDarkTheme.disabled = false;
        var btnLightTheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
        btnLightTheme.disabled = true;
        $('#hdnDarkTheme').val('OFF');
        $('#hdnLightTheme').val('ON');
        return;
      }
    }
    if (event.target.id == "btnLightTheme") {
      document.getElementById('theme').setAttribute('href', 'assets/css/master.css');
      if ($('#btnLightTheme').val() == "ON") {
        var darkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
        darkTheme.value = "ON";
        $('#btnLightTheme').val('OFF');
        var btnDarkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
        btnDarkTheme.disabled = true;
        var btnLightTheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
        btnLightTheme.disabled = false;
        $('#hdnDarkTheme').val('ON');
        $('#hdnLightTheme').val('OFF');
        return;
      }
      if ($('#btnLightTheme').val() == "OFF") {
        var darkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
        darkTheme.value = "OFF";
        $('#btnLightTheme').val('ON');
        var btnDarkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
        btnDarkTheme.disabled = false;
        var btnLightTheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
        btnLightTheme.disabled = true;
        $('#hdnDarkTheme').val('OFF');
        $('#hdnLightTheme').val('ON');
        return;
      }
    }
    if (event.target.id == "LogoutPageHit") {
      this.registrationservice.LogoutInvestorAccount().subscribe(data => {
      });
      CheckforSession(event.target.id);
      this.InvestorAccount();
      return;
    }

    if (event.target.id == "fontDecrease") {
      decreaseFontSize();
      decreaseFontSizeH3();
      decreaseFontSizeH4();
      decreaseFontSizeinput();
      decreaseFontSizetextarea();
      decreaseFontSizeH2();
      decreaseFontSizetd();
      decreaseFontSizelabel();
      decreaseFontSizespan();


    }
    if (event.target.id == "fontIncrease") {
      increaseFontSize();
      increaseFontSizeH3();
      increaseFontSizeH4();
      increaseFontSizeinput();
      increaseFontSizetextarea();
      increaseFontSizeH2();
      increaseFontSizetd();
      increaseFontSizelabel();
      increaseFontSizespan();

    }

    if (event.target.id == "resetFontSize") {
      resetFontSize();
    }

    this.pathname = window.location.href;
    debugger;
    if (event.target.innerText == "Skip to Main Content") {
      if (this.pathname.includes("Dachomepage")) {
        document.getElementById("lblDACForIssuersandObligors").focus();
        document.getElementById("lblDACForIssuersandObligors").tabIndex = 24;
        HomeresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblDACForIssuersandObligors").innerText, document.getElementById("lblDACForIssuersandObligors").id, event.target.type, document.getElementById("lblDACForIssuersandObligors").title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (this.pathname.includes("IssuersandObligors")) {
        document.getElementById("lblIssuersandObligors").focus();
        document.getElementById("lblIssuersandObligors").tabIndex = 23;
        IssuersAndObligorsVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblIssuersandObligors").innerText, document.getElementById("lblIssuersandObligors").id, event.target.type, document.getElementById("lblIssuersandObligors").title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (this.pathname.includes("DACForInvestors")) {
        document.getElementById("lblInvestors").focus();
        document.getElementById("lblInvestors").tabIndex = 23;
        DACForInvestorsVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblInvestors").innerText, document.getElementById("lblInvestors").id, event.target.type, document.getElementById("lblInvestors").title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (this.pathname.includes("dmca")) {
        document.getElementById("lblDMCA").focus();
        document.getElementById("lblDMCA").tabIndex = 23;
        DMCAresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblDMCA").innerText, document.getElementById("lblDMCA").id, event.target.type, document.getElementById("lblDMCA").title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (this.pathname.includes("legal-information")) {
        document.getElementById("lblLegalInfo").focus();
        document.getElementById("lblLegalInfo").tabIndex = 23;
        LegalInformationresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblLegalInfo").innerText, document.getElementById("lblLegalInfo").id, event.target.type, document.getElementById("lblLegalInfo").title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (this.pathname.includes("aboutus")) {
        document.getElementById("lblabout").focus();
        document.getElementById("lblabout").tabIndex = 23;
        AboutresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblabout").innerText, document.getElementById("lblabout").id, event.target.type, document.getElementById("lblabout").title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (this.pathname.includes("aboutUsSecurities")) {
        document.getElementById("lblSecurities").focus();
        document.getElementById("lblSecurities").tabIndex = 23;
        AboutSecuritiesresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblSecurities").innerText, document.getElementById("lblSecurities").id, event.target.type, document.getElementById("lblSecurities").title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (this.pathname.includes("PostIssuanceTaxComplianceComponent")) {
        document.getElementById("lblTaxCompliance").focus();
        document.getElementById("lblTaxCompliance").tabIndex = 23;
        AboutComplianceresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblTaxCompliance").innerText, document.getElementById("lblTaxCompliance").id, event.target.type, document.getElementById("lblTaxCompliance").title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (this.pathname.includes("help")) {
        document.getElementById("lblhelp").focus();
        document.getElementById("lblhelp").tabIndex = 23;
        HelpresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblhelp").innerText, document.getElementById("lblhelp").id, event.target.type, document.getElementById("lblhelp").title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (this.pathname.includes("sitemap")) {
        document.getElementById("lblSitemap").focus();
        document.getElementById("lblSitemap").tabIndex = 23;
        SitemapresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblSitemap").innerText, document.getElementById("lblSitemap").id, event.target.type, document.getElementById("lblSitemap").title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (this.pathname.includes("registration")) {
        document.getElementById("emaillabel").focus();
        document.getElementById("emaillabel").tabIndex = 23;
        responsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("emaillabel").innerText, document.getElementById("emaillabel").id, event.target.type, document.getElementById("emaillabel").title, event.target.htmlFor, event.target.alt, event.key);
        return;
      }
      if (this.pathname.includes("Annualfinancial") || this.pathname.includes("Budgets") || this.pathname.includes("Interim") || this.pathname.includes("Failure")
        || this.pathname.includes("OtherFinancial") || this.pathname.includes("OtherEvent") || this.pathname.includes("RatingChange") || this.pathname.includes("Unscheduled") || this.pathname.includes("BondCalls")) {
        document.getElementById("lblObligar").focus();
        document.getElementById("lblObligar").tabIndex = 151;
        responsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblObligar").innerText, document.getElementById("lblObligar").id, event.target.type, document.getElementById("lblObligar").title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (this.pathname.includes("investor-browse-filing-types")) {
        document.getElementById("DocumentCategories").focus();
        document.getElementById("DocumentCategories").tabIndex = 23;
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("DocumentCategories").innerText, document.getElementById("DocumentCategories").id, event.target.type, document.getElementById("DocumentCategories").title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (this.pathname.includes("investor-browse-borrowing-documents")) {
        document.getElementById("DocumentOverviewCategories").focus();
        document.getElementById("DocumentOverviewCategories").tabIndex = 23;
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("DocumentOverviewCategories").innerText, document.getElementById("DocumentOverviewCategories").id, event.target.type, document.getElementById("DocumentOverviewCategories").title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (this.pathname.includes("ask-aquestion")) {
        document.getElementById("pageAksID").focus();
        document.getElementById("pageAksID").tabIndex = 23;
        responsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("Email").innerText, document.getElementById("Email").id, event.target.type, document.getElementById("Email").title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (this.pathname.includes("browse-obligor")) {
        document.getElementById("BrowseObligors").focus();
        document.getElementById("BrowseObligors").tabIndex = 23;
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("BrowseObligors").innerText, document.getElementById("BrowseObligors").id, event.target.type, document.getElementById("BrowseObligors").title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (this.pathname.includes("Accessingwebcasts")) {
        document.getElementById("lblWebcasts").focus();
        document.getElementById("lblWebcasts").tabIndex = 23;
        WebCastresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblWebcasts").innerText, document.getElementById("lblWebcasts").id, event.target.type, document.getElementById("lblWebcasts").title, event.target.htmlFor, event.target.alt, event.key);
      }
    }
  }
  onKeyUp(event: any) {
    debugger;

    if (event.target.id == "LogoutPage" && event.keyCode == 9) {
      //document.getElementById("Dropdownuser").style.display = "block";
      HomeresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      return;
    }

    if (event.target.id == "LogoutPage" && event.keyCode == 16) {
      //document.getElementById("Dropdownuser").style.display = "block";
      HomeresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      return;
    }

    if (event.target.id == "btnComboLogin" && event.keyCode == 9) {
      //document.getElementById("Dropdownuser").style.display = "block";
      HomeresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      return;
    }
    //if (event.target.id == "SkipMainContent" && (event.keyCode == 9)) {
    //  this.onLoginOpen(event);
    //  return;
    //}
    if (event.target.id == "DacBondLogo" && (event.shiftKey && event.keyCode == 9)) {
      $("#settings").trigger("click");
      return;
    }
    if (event.target.id == "Investerlogin" && event.keyCode == 9) {
      HomeresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      return;
    }
    if (event.target.id == "btnComboLogin" && event.keyCode == 27) {
      document.getElementById("HomeLogo").focus();

      HomeresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, "HomeLogo", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      return;
    }
    if (event.target.id == "decreasevoice" && event.keyCode == 13) {
      decreaseVoiceSpeed();
      voiceforincreasedecrease(event.target.id)
      return;
    }
    if (event.target.id == "increasevoice" && event.keyCode == 13) {
      increaseVoiceSpeed();
      voiceforincreasedecrease(event.target.id)
      return;
    }
    if (event.target.id == "voicespeed" && event.keyCode == 13) {
      resetVoiceSpeed();
      voiceforincreasedecrease(event.target.id)
      return;
    }
    if ((event.target.id == "settings" || event.target.id == "IncreaseFont" || event.target.id == "decreaseFont" || event.target.id == "ResetFont"
      || event.target.id == "voiceannotation" || event.target.id == "decreasevoice" || event.target.id == "increasevoice" || event.target.id == "voicespeed"
      || event.target.id == "captiononoff" || event.target.id == "darkertheme" || event.target.id == "lighttheme" || event.target.id == "magnifier") && (event.keyCode == 27)) {
      document.getElementById("settings").click();
      HomeresponsiveVoiceSpeak(event.target.placeholder, event.target.value, 9, "Skip to Main Content", "SkipMainContent", "", "", "", "", "");
      document.getElementById("SkipMainContent").focus();
      return;
    }
    if (event.target.id == "darkertheme" && event.keyCode == 13) {
      var darkerthemeBtn = <HTMLButtonElement>document.getElementById('btnDarkTheme');
      if (darkerthemeBtn.disabled == true) {
        event.preventDefault();
        return;
      }

      document.getElementById('theme').setAttribute('href', 'assets/style-sheet/mastertheme.css');
      if ($('#btnDarkTheme').val() == "OFF") {
        var lighttheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
        lighttheme.value = "OFF";
        $('#btnDarkTheme').val('ON');
        var btnDarkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
        btnDarkTheme.disabled = true;
        var btnLightTheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
        btnLightTheme.disabled = false;
        SettingsVoice(event.target.id);
        $('#hdnDarkTheme').val('ON');
        $('#hdnLightTheme').val('OFF');
        return;
      }
      if ($('#btnDarkTheme').val() == "ON") {
        var lighttheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
        lighttheme.value = "ON";
        $('#btnDarkTheme').val('OFF');
        var btnDarkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
        btnDarkTheme.disabled = false;
        var btnLightTheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
        btnLightTheme.disabled = true;
        SettingsVoice(event.target.id);
        $('#hdnDarkTheme').val('OFF');
        $('#hdnLightTheme').val('ON');
        return;
      }
    }
    if (event.target.id == "lighttheme" && event.keyCode == 13) {
      var LightThemeBtn = <HTMLButtonElement>document.getElementById('btnLightTheme');
      if (LightThemeBtn.disabled == true) {
        event.preventDefault();
        return;
      }

      document.getElementById('theme').setAttribute('href', 'assets/css/master.css');
      if ($('#btnLightTheme').val() == "ON") {
        var darkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
        darkTheme.value = "ON";
        $('#btnLightTheme').val('OFF');
        var btnDarkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
        btnDarkTheme.disabled = true;
        var btnLightTheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
        btnLightTheme.disabled = false;
        SettingsVoice(event.target.id);
        $('#hdnDarkTheme').val('ON');
        $('#hdnLightTheme').val('OFF');
        return;
      }
      if ($('#btnLightTheme').val() == "OFF") {
        var darkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
        darkTheme.value = "OFF";
        $('#btnLightTheme').val('ON');
        var btnDarkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
        btnDarkTheme.disabled = false;
        var btnLightTheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
        btnLightTheme.disabled = true;
        SettingsVoice(event.target.id);
        $('#hdnDarkTheme').val('OFF');
        $('#hdnLightTheme').val('ON');
        return;
      }
    }
    if (event.target.id == "captiononoff" && event.keyCode == 13) {
      if ($('#btnOnOff').val() == "OFF") {
        $('#btnOnOff').val('ON')
        $('#captionhideshow').show();
        $('#hidglbVarOnOff').val('ON');
      }
      else {
        $('#captionhideshow').hide();
        $('#btnOnOff').val('OFF')
        $('#hidglbVarOnOff').val('OFF');
      }
      SettingsVoice(event.target.id);
      return;
    }
    if (event.target.id == "magnifier" && event.keyCode == 13) {
      if ($('#btnMagnify').val() == "DISABLE") {
        $('#btnMagnify').val('ENABLE')
        $('#hdnMagnifierDisable').val('ENABLE');
      }
      else {
        $('#btnMagnify').val('DISABLE')
        $('#hdnMagnifierDisable').val('DISABLE');
      }
      SettingsVoice(event.target.id);
      MagnifierEnableDisable($('#hdnMagnifierDisable').val());
      return;
    }
    if (event.target.id == "voiceannotation" && event.keyCode == 13) {
      if ($('#btnVoiceAnnotation').val() == "OFF") {
        $('#btnVoiceAnnotation').val('ON');
        $('#hidVoiceOnOff').val('ON');
        //$('#btnPlayPause').attr('src', ('assets/images/play-button.png'));
        $('#btnPlayPause').css('display', 'block');
      }
      else {
        $('#btnVoiceAnnotation').val('OFF');
        $('#hidVoiceOnOff').val('OFF');
        //$('#btnPlayPause').attr('src', ('assets/images/pause.png'));
        $('#btnPlayPause').css('display', 'none');
      }
    }
    if ((event.target.id == "decreaseFont" || event.target.id == "IncreaseFont" || event.target.id == "ResetFont"
      || event.target.id == "voiceannotation" || event.target.id == "captiononoff"
      || event.target.id == "darkertheme" || event.target.id == "lighttheme") && event.keyCode == 13) {
      debugger;
      SettingsVoice(event.target.id);
    }

    if (event.target.id == "decreaseFont" && event.keyCode == 13) {
      decreaseFontSize();
      decreaseFontSizeH3();
      decreaseFontSizeH4();
      decreaseFontSizeinput();
      decreaseFontSizetextarea();
      decreaseFontSizeH2();
      decreaseFontSizetd();
      decreaseFontSizelabel();
      return;
    }
    if (event.target.id == "IncreaseFont" && event.keyCode == 13) {
      increaseFontSize();
      increaseFontSizeH3();
      increaseFontSizeH4();
      increaseFontSizeinput();
      increaseFontSizetextarea();
      increaseFontSizeH2();
      increaseFontSizetd();
      increaseFontSizelabel();
      return;
    }

    if (event.target.id == "ResetFont" && event.keyCode == 13) {
      resetFontSize();
      return;
    }

    this.pathname = window.location.href;
    if (event.keyCode == 9 || event.keyCode == 13) {
      if (event.target.id == "LogoutPage" && event.keyCode == 13) {
        this.registrationservice.LogoutInvestorAccount().subscribe(data => {
        });
      }

      if (event.target.id == "LogoutPageHit" && event.keyCode == 13) {
        this.registrationservice.LogoutInvestorAccount().subscribe(data => {
        });
        CheckforSession(event.target.id);
        this.InvestorAccount();
        return;
      }

      if (event.target.id == "LogoutPage" && event.keyCode == 16) {

        return;

      }

      if (event.target.id == "LogoutPage") {
        this.InvestorAccount();
      }
      else if (event.target.id == "DacBondLogo" && event.keyCode == 13) {
        if (this.pathname.includes("registration") || this.pathname.includes("IssuersandObligors") || this.pathname.includes("DACForInvestors") || this.pathname.includes("dmca")
          || this.pathname.includes("legal-information") || this.pathname.includes("help") || this.pathname.includes("sitemap") || this.pathname.includes("Accessingwebcasts")
          || this.pathname.includes("investor-browse-filing-types") || this.pathname.includes("investor-browse-borrowing-documents") || this.pathname.includes("Annualfinancial") || this.pathname.includes("Budgets") || this.pathname.includes("Interim")
          || this.pathname.includes("Failure") || this.pathname.includes("OtherFinancial") || this.pathname.includes("OtherEvent") || this.pathname.includes("RatingChange")
          || this.pathname.includes("Unscheduled") || this.pathname.includes("BondCalls") || this.pathname.includes("browse-obligor") || this.pathname.includes("aboutus")
          || this.pathname.includes("aboutus") || this.pathname.includes("aboutUsSecurities") || this.pathname.includes("PostIssuanceTaxComplianceComponent")
          || this.pathname.includes("ask-aquestion")) {
          this.router.navigate(['/Dachomepage']);
          return;
        }
      }
      HomeresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
    }
  };
  onkeypress(event: any) {
    debugger;

    if (event.target.id == "DacBondLogo" && (event.shiftKey && event.keyCode == 9)) {
      $("#settings").trigger("click");
      return;
    }
    if (event.target.id == "Investerlogin" && event.keyCode == 13) {
      this.router.navigate(['/registration']);
    }
    if (event.target.id == "Issuerlogin" && event.keyCode == 13) {
      document.getElementById("issueraccessible").click();

    }

    if (event.target.id == "LogoutPage" && event.keyCode == 13) {
      this.registrationservice.LogoutInvestorAccount().subscribe(data => {
      });
      CheckforSession("LogoutPageHit");
      this.InvestorAccount();
      return;
    }
    // find specified path
    this.pathname = window.location.href;
    if (event.keyCode == 9 || event.keyCode == 13) {
      if (event.target.innerText == "Skip to Main Content") {
        if (this.pathname.includes("Dachomepage")) {
          document.getElementById("lblDACForIssuersandObligors").focus();
          document.getElementById("lblDACForIssuersandObligors").tabIndex = 24;
          HomeresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblDACForIssuersandObligors").innerText, event.target.id, event.target.type, document.getElementById("lblDACForIssuersandObligors").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (this.pathname.includes("IssuersandObligors")) {
          document.getElementById("lblIssuersandObligors").focus();
          document.getElementById("lblIssuersandObligors").tabIndex = 23;
          IssuersAndObligorsVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblIssuersandObligors").innerText, document.getElementById("lblIssuersandObligors").id, event.target.type, document.getElementById("lblIssuersandObligors").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (this.pathname.includes("DACForInvestors")) {
          document.getElementById("lblInvestors").focus();
          document.getElementById("lblInvestors").tabIndex = 23;
          DACForInvestorsVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblInvestors").innerText, document.getElementById("lblInvestors").id, event.target.type, document.getElementById("lblInvestors").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (this.pathname.includes("dmca")) {
          document.getElementById("lblDMCA").focus();
          document.getElementById("lblDMCA").tabIndex = 23;
          DMCAresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblDMCA").innerText, document.getElementById("lblDMCA").id, event.target.type, document.getElementById("lblDMCA").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (this.pathname.includes("legal-information")) {
          document.getElementById("lblLegalInfo").focus();
          document.getElementById("lblLegalInfo").tabIndex = 23;
          LegalInformationresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblLegalInfo").innerText, document.getElementById("lblLegalInfo").id, event.target.type, document.getElementById("lblLegalInfo").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (this.pathname.includes("aboutus")) {
          document.getElementById("lblabout").focus();
          document.getElementById("lblabout").tabIndex = 23;
          AboutresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblabout").innerText, document.getElementById("lblabout").id, event.target.type, document.getElementById("lblabout").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (this.pathname.includes("aboutUsSecurities")) {
          document.getElementById("lblSecurities").focus();
          document.getElementById("lblSecurities").tabIndex = 23;
          AboutSecuritiesresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblSecurities").innerText, document.getElementById("lblSecurities").id, event.target.type, document.getElementById("lblSecurities").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (this.pathname.includes("PostIssuanceTaxComplianceComponent")) {
          document.getElementById("lblTaxCompliance").focus();
          document.getElementById("lblTaxCompliance").tabIndex = 23;
          AboutComplianceresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblTaxCompliance").innerText, document.getElementById("lblTaxCompliance").id, event.target.type, document.getElementById("lblTaxCompliance").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (this.pathname.includes("help")) {
          document.getElementById("lblhelp").focus();
          document.getElementById("lblhelp").tabIndex = 23;
          HelpresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblhelp").innerText, document.getElementById("lblhelp").id, event.target.type, document.getElementById("lblhelp").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (this.pathname.includes("sitemap")) {
          document.getElementById("lblSitemap").focus();
          document.getElementById("lblSitemap").tabIndex = 23;
          SitemapresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblSitemap").innerText, document.getElementById("lblSitemap").id, event.target.type, document.getElementById("lblSitemap").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (this.pathname.includes("registration")) {
          document.getElementById("emaillabel").focus();
          document.getElementById("emaillabel").tabIndex = 23;
          responsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("emaillabel").innerText, document.getElementById("emaillabel").id, event.target.type, document.getElementById("emaillabel").title, event.target.htmlFor, event.target.alt, event.key);
          return;
        }
        if (this.pathname.includes("Annualfinancial") || this.pathname.includes("Budgets") || this.pathname.includes("Interim") || this.pathname.includes("Failure")
          || this.pathname.includes("OtherFinancial") || this.pathname.includes("OtherEvent") || this.pathname.includes("RatingChange") || this.pathname.includes("Unscheduled") || this.pathname.includes("BondCalls")
          || this.pathname.includes("DisclosuresID")) {
          document.getElementById("lblObligar").focus();
          document.getElementById("lblObligar").tabIndex = 151;
          responsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblObligar").innerText, document.getElementById("lblObligar").id, event.target.type, document.getElementById("lblObligar").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (this.pathname.includes("investor-browse-filing-types")) {
          document.getElementById("DocumentCategories").focus();
          document.getElementById("DocumentCategories").tabIndex = 23;
          FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("DocumentCategories").innerText, document.getElementById("DocumentCategories").id, event.target.type, document.getElementById("DocumentCategories").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (this.pathname.includes("investor-browse-borrowing-documents")) {
          document.getElementById("DocumentOverviewCategories").focus();
          document.getElementById("DocumentOverviewCategories").tabIndex = 23;
          FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("DocumentOverviewCategories").innerText, document.getElementById("DocumentOverviewCategories").id, event.target.type, document.getElementById("DocumentOverviewCategories").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (this.pathname.includes("ask-aquestion")) {
          document.getElementById("pageAksID").focus();
          document.getElementById("pageAksID").tabIndex = 23;
          responsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("Email").innerText, document.getElementById("Email").id, event.target.type, document.getElementById("Email").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (this.pathname.includes("browse-obligor")) {
          document.getElementById("BrowseObligors").focus();
          document.getElementById("BrowseObligors").tabIndex = 23;
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("BrowseObligors").innerText, document.getElementById("BrowseObligors").id, event.target.type, document.getElementById("BrowseObligors").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (this.pathname.includes("Accessingwebcasts")) {
          document.getElementById("lblWebcasts").focus();
          document.getElementById("lblWebcasts").tabIndex = 23;
          WebCastresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblWebcasts").innerText, document.getElementById("lblWebcasts").id, event.target.type, document.getElementById("lblWebcasts").title, event.target.htmlFor, event.target.alt, event.key);
        }
      }
    }
    //HomevoiceOnKeyPress(event.target.value, event.key);
  };
  toggle(event: any) {
    debugger;
    if (event.target.id == "btnOnOff") {
      if ($('#btnOnOff').val() == "OFF") {
        $('#btnOnOff').val('ON')
        $('#captionhideshow').show();
        $('#hidglbVarOnOff').val('ON');
      }
      else {
        $('#captionhideshow').hide();
        $('#btnOnOff').val('OFF')
        $('#hidglbVarOnOff').val('OFF');
      }
    }
    if (event.target.id == "btnVoiceAnnotation") {
      if ($('#btnVoiceAnnotation').val() == "OFF") {
        $('#btnVoiceAnnotation').val('ON');
        $('#hidVoiceOnOff').val('ON');
        //$('#btnPlayPause').attr('src', ('assets/images/play-button.png'));
        $('#btnPlayPause').css('display', 'block');
      }
      else {
        $('#btnVoiceAnnotation').val('OFF');
        $('#hidVoiceOnOff').val('OFF');
        //$('#btnPlayPause').attr('src', ('assets/images/pause.png'));
        $('#btnPlayPause').css('display', 'none');
      }
    }
    if (event.target.id == "btnMagnify") {
      if ($('#btnMagnify').val() == "DISABLE") {
        $('#btnMagnify').val('ENABLE')
        $('#hdnMagnifierDisable').val('ENABLE');
        MagnifierEnableDisable("ENABLE");
      }
      else {
        $('#btnMagnify').val('DISABLE')
        $('#hdnMagnifierDisable').val('DISABLE');
        MagnifierEnableDisable("DISABLE");
      }
    }
  }
  InvestorAccount() {
    debugger;

    this.checksessionStorage();

    //this.pathname = window.location.pathname;
    //if (sessionStorage.length == 0) {
    //  document.getElementById("loginPage").style.display = "block";
    //  document.getElementById("LogoutPage").style.display = "none";
    //  document.getElementById("BrowseObligorPage").style.display = "none";
    //}
    //if (sessionStorage.length == 1) {
    //  document.getElementById("loginPage").style.display = "none";
    //  document.getElementById("LogoutPage").style.display = "block";
    //  document.getElementById("BrowseObligorPage").style.display = "block";
    //}

    //if (this.pathname.includes("browse-obligor")) {
    //  document.getElementById("BrowseObligorPage").style.display = "none";
    //}
  }
  ngOnInit() {
    debugger;
    LoadSettingsDropdown();
    this.pathname = window.location.href;
    document.getElementById("divHideHeaderTab").focus();
    window.scrollTo(0, 0); // Set scroll postion top when any component load.
    //LoadZoomText();   
    // Check for session and Hide show BrowseObligor Page Link on the basis of session.    
    //if (!sessionStorage['sessionData']) {
    //  //document.getElementById("loginPage").style.display = "block";
    //  document.getElementById("LogoutPage").style.display = "none";
    //  document.getElementById("BrowseObligorPage").style.display = "none";
    //}
    //if (sessionStorage.length == 1) {
    //  if (sessionStorage['sessionData']) {
    //    //document.getElementById("loginPage").style.display = "none";
    //    document.getElementById("LogoutPage").style.display = "block";
    //    document.getElementById("BrowseObligorPage").style.display = "block";
    //  }
    //}
    this.checksessionStorage();
    if (this.pathname.includes("browse-obligor")) {
      document.getElementById("BrowseObligorPage").style.display = "none";
    }

  }
  ngAfterViewInit() {
    debugger;
    // Set Magnifier button Enable/Disable
    if ($('#hdnMagnifierDisable').val() == "ENABLE") {
      $('#btnMagnify').val('ENABLE')
      MagnifierEnableDisable("ENABLE");
    }
    else {
      $('#btnMagnify').val('DISABLE')
      MagnifierEnableDisable("DISABLE");
    }

    // Set application level Light and Dark Theme button enable/disable on the basis of Settings.

    // Darker Theme
    var btnDarkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
    var btnLightTheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
    if ($('#hdnDarkTheme').val() == "OFF") {
      btnDarkTheme.value = "OFF";
      btnLightTheme.value = "ON";
      btnDarkTheme.disabled = false;
      btnLightTheme.disabled = true;
    }
    if ($('#hdnDarkTheme').val() == "ON") {
      btnDarkTheme.value = "ON";
      btnLightTheme.value = "OFF";
      btnDarkTheme.disabled = true;
      btnLightTheme.disabled = false;
    }
    // Lighter Theme        
    if ($('#hdnLightTheme').val() == "OFF") {
      btnDarkTheme.value = "ON";
      btnLightTheme.value = "OFF";
      btnDarkTheme.disabled = true;
      btnLightTheme.disabled = false;
    }
    if ($('#hdnLightTheme').val() == "ON") {
      btnDarkTheme.value = "OFF";
      btnLightTheme.value = "ON";
      btnDarkTheme.disabled = false;
      btnLightTheme.disabled = true;
    }

    FontSizeSettings();
  }

  //Check for session and Hide show BrowseObligor Page Link on the basis of session.

  checksessionStorage() {
    debugger;
    this.pathname = window.location.href;

    if (!sessionStorage['sessionData']) {
      this.Islogin = true;
      document.getElementById("LogoutPage").style.display = "none";
      document.getElementById("BrowseObligorPage").style.display = "none";
      if (document.getElementById("btnComboLogin") != null || document.getElementById("btnComboLogin") != undefined) {
        document.getElementById("btnComboLogin").style.display = "block";
      }
    }

    if (this.pathname.includes("Accessingwebcasts") || this.pathname.includes("ask-aquestion") || this.pathname.includes("investor-browse-borrowing-documents") || this.pathname.includes("browse-obligor") || this.pathname.includes("investor-browse-filing-types")) {
      this.checkObligorData();
      if (!sessionStorage['sessionData']) {
        this.Islogin = true;
        if (document.getElementById("btnComboLogin") != null || document.getElementById("btnComboLogin") != undefined) {
          document.getElementById("btnComboLogin").style.display = "block";
        }
        if (document.getElementById("loginAction") != null || document.getElementById("loginActions") != undefined) {
          document.getElementById("loginAction").style.display = "block";
        }
        document.getElementById("LogoutPage").style.display = "none";
        document.getElementById("BrowseObligorPage").style.display = "none";
        // check session only
        debugger;


        var cookiesessionId = this.cookieService.get('JSESSIONID');
        this.router.navigate(['registration']);

        //if ((cookiesessionId == "" || cookiesessionId == undefined || cookiesessionId == null) && this.pathname.includes("Accessingwebcasts") || this.pathname.includes("ask-aquestion") || this.pathname.includes("investor-browse-borrowing-documents") || this.pathname.includes("browse-obligor") || this.pathname.includes("investor-browse-filing-types")) {
        //  this.router.navigate(['registration']);
        //  return;
        //}

      }
    }
    if (sessionStorage['sessionData']) {
      this.Islogin = false;
      //document.getElementById("loginAction").style.display = "none";
      if (document.getElementById("btnComboLogin") != null || document.getElementById("btnComboLogin") != undefined) {
        document.getElementById("btnComboLogin").style.display = "none";
      }
      document.getElementById("LogoutPage").style.display = "block";
      document.getElementById("BrowseObligorPage").style.display = "block";

    }
  }
  //add jsession cookie checkings
  checkObligorData() {
    var SearchObligorsValue = "A";
    this.browseobligorService.GetInvestorBrowseObligors(SearchObligorsValue).subscribe(data => {
      debugger;
      var result = data;

    },
      error => {
        console.log(error);
        console.log(error.status);
        if (error.status == "403") {
          sessionStorage.removeItem("sessionData");


        }
      });

    return;
  }
  // old code commented
  //checksessionStorage() {
  //  debugger;
  //  if (!sessionStorage['sessionData']) {
  //    this.Islogin = true;
  //    if (document.getElementById("btnComboLogin") != null || document.getElementById("btnComboLogin") != undefined) {
  //      document.getElementById("btnComboLogin").style.display = "block";
  //    }
  //    if (document.getElementById("loginAction") != null || document.getElementById("loginActions") != undefined) {
  //      document.getElementById("loginAction").style.display = "block";
  //    }
  //    document.getElementById("LogoutPage").style.display = "none";
  //    document.getElementById("BrowseObligorPage").style.display = "none";

  //    // check session only below pages
  //    this.pathname = window.location.pathname;
  //    var cookiesessionId = this.cookieService.get('JSESSIONID');
  //    if (this.pathname.includes("Accessingwebcasts") || this.pathname.includes("ask-aquestion") || this.pathname.includes("investor-browse-borrowing-documents") || this.pathname.includes("browse-obligor") || this.pathname.includes("investor-browse-filing-types")) {
  //       this.router.navigate(['registration']);
  //      return;
  //    }
  //    //if ((cookiesessionId == "" || cookiesessionId == undefined || cookiesessionId == null) && this.pathname.includes("Accessingwebcasts") || this.pathname.includes("ask-aquestion") || this.pathname.includes("investor-browse-borrowing-documents") || this.pathname.includes("browse-obligor") || this.pathname.includes("investor-browse-filing-types")) {
  //    //  this.router.navigate(['registration']);
  //    //  return;
  //    //}
      

  //  }
  //  if (sessionStorage['sessionData']) {
  //    this.Islogin = false;
  //    //document.getElementById("loginAction").style.display = "none";
  //    if (document.getElementById("btnComboLogin") != null || document.getElementById("btnComboLogin") != undefined) {
  //      document.getElementById("btnComboLogin").style.display = "none";
  //    }
  //    document.getElementById("LogoutPage").style.display = "block";
  //    document.getElementById("BrowseObligorPage").style.display = "block";

  //  }
  //}
  onLoginOpen(event: any) {

    if (document.getElementById("Dropdownuser").style.display == "block") {
      document.getElementById("Dropdownuser").style.display = "none";
    }
    else {
      document.getElementById("Dropdownuser").style.display = "block";
    }

    return;

  }
}

